import styled from 'styled-components'

export const StatCard = styled.div`
  background: #111;
  border: 1px solid rgba(255, 255, 255, 0.07);
  border-radius: 8px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 0;
  min-height: 160px;
  font-family: -apple-system, BlinkMacSystemFont, 'Inter', 'DMSans', sans-serif;
`

export const CardLabel = styled.div`
  color: #a1a1a1;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.07em;
  font-weight: 600;
  margin-bottom: 12px;
`

export const CardValue = styled.div`
  color: #ededed;
  font-size: 26px;
  font-weight: 700;
  letter-spacing: -0.03em;
  line-height: 1;
  font-variant-numeric: tabular-nums;
  margin-bottom: 2px;
`

export const CardUnit = styled.span`
  font-size: 13px;
  font-weight: 400;
  color: #777;
  margin-left: 4px;
  letter-spacing: 0;
`

export const CardSub = styled.div`
  color: #777;
  font-size: 12px;
  margin-top: 4px;
`

export const ProgressBar = styled.div<{ percent: number; ok: boolean }>`
  height: 2px;
  background: rgba(255, 255, 255, 0.06);
  border-radius: 2px;
  overflow: hidden;
  margin: 10px 0 8px;

  &::after {
    content: '';
    display: block;
    height: 100%;
    width: ${({ percent }) => Math.min(Math.max(percent, 0), 100)}%;
    background: ${({ ok }) => ok ? '#33C2B0' : '#ff4444'};
    border-radius: 2px;
    transition: width 0.4s ease;
  }
`

export const Divider = styled.div`
  border-top: 1px solid rgba(255, 255, 255, 0.06);
  margin: 10px 0;
`

export const SubRow = styled.div`
  display: flex;
  gap: 20px;
  margin-top: auto;
  padding-top: 10px;
`

export const SubStat = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`

export const SubStatValue = styled.div`
  color: #ededed;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: -0.02em;
  font-variant-numeric: tabular-nums;
`

export const SubStatLabel = styled.div`
  color: #777;
  font-size: 10px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
`

export const StatusDot = styled.span<{ ok: boolean }>`
  display: inline-block;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: ${({ ok }) => ok ? '#33C2B0' : '#ff4444'};
  margin-right: 6px;
`
